/*
* <license header>
*/

import React, { useState } from 'react'
import { Button, Flex, TextArea, View } from '@adobe/react-spectrum'
import Send from '@spectrum-icons/workflow/Send'

export const MessageSection = ({ onSend, initialMessage }) => {
  const [message, setMessage] = useState(initialMessage || '')

  const handleSend = () => {
    if (message.trim()) {
      onSend?.(message.trim())
      setMessage('')
    }
  }

  return (
    <View
      UNSAFE_style={{
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1rem',
        backgroundColor: 'var(--white)'
      }}
    >
      <Flex gap="size-100" alignItems="end">
        <View flex={1} minWidth={0}>
          <TextArea
            aria-label="Message"
            placeholder="Ask the AppBuilder Factory Assistant anything. Describe your need with as much detail as possible for better results."
            value={message}
            onChange={setMessage}
            width="100%"
            minHeight="size-600"
          />
        </View>
        <Button variant="accent" onPress={handleSend}>
          <Send size="S" />
          <span style={{ marginLeft: '0.5rem' }}>Send</span>
        </Button>
      </Flex>
    </View>
  )
}
